import { React, useState, useEffect } from "react";
// import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  Container,
  Form,
  FormGroup,
  Col,
  Row,
  Label,
  Button,
  Input,
} from "reactstrap";
import Modal from "react-modal";
import { resetPassword } from "../../../actions/users";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import ErrorMessage from "../../Utils/ErrorMessage";
import { ToolTip } from "../../Utils/utils";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    border: "8px solid #9ba5ad",
    // height: '95%',
  },
};

function ResetForm(props) {
  const dispatch = useDispatch();
  const { userDetails, success } = useSelector((state) => state?.users);

  // const clearUserDetailsFn = () =>
  //   dispatch({ type: "SET_USER_DETAILS", data: { userDetails: undefined } });
  const resetPasswordFn = (details) => dispatch(resetPassword(details));

  const [currState, setCurrState] = useState({
    input: {},
    errors: {},
    password: "",
  });

  useEffect(() => {
    return () => {
      dispatch({ type: "SET_USER_DETAILS", data: { userDetails: undefined } });
    };
  }, [dispatch]);

  const {
    "custom:uid": uid,
    email,
    given_name,
    family_name,
    "custom:company": company,
  } = userDetails;

  // useEffect(() => {
  //   console.log("userDetails====>", userDetails);
  //   console.log("errors====>", currState?.errors);
  // }, [userDetails]);
  const { password } = currState;
  if (success) props.toggle();

  return (
    <>
      <Modal
        isOpen={props.modal}
        style={customStyles}
        ariaHideApp={false}
        onRequestClose={props.toggle}
      >
        <Container fluid>
          <Formik
            initialValues={{
              password: "",
              confirm_password: "",
            }}
            validationSchema={Yup.object().shape({
              password: Yup.string()
                .required("Please fill the field")
                .test("validatePassword", "Invalid password pattern", (p) => {
                  return /[A-Z]/.test(p) &&
                    /[0-9]/.test(p) &&
                    /[a-z]/.test(p) &&
                    /(?=.*[!@#$%^&*(){|}"'-_+=`~])/.test(p) &&
                    p.length > 15
                    ? true
                    : false;
                }),
              confirm_password: Yup.string()
                .required("Please fill the field")
                .test(
                  "validateConfirmPassword",
                  `Passwords don't match`,
                  (confirm_password) => {
                    return password === confirm_password ? true : false;
                  }
                ),
            })}
            onSubmit={(values) => {
              // console.log("values====>", values);
              let body = {
                username: email,
                firstName: given_name,
                password: currState?.password,
              };
              // console.log("body====>", body);
              resetPasswordFn(body);
            }}
          >
            {({ handleSubmit, touched, errors, setFieldValue, values }) => (
              <>
                <Form onSubmit={handleSubmit}>
                  <div
                    style={{ float: "Right", cursor: "pointer" }}
                    onClick={(e) => props.toggle()}
                  >
                    <b>X</b>
                  </div>
                  <h5>Reset Password</h5>
                  <hr />
                  {/*<table className="resetFormTable">
												<tr>
													<td className="resetFormTable" >User ID</td>
													<td className="resetFormTable">{uid}</td>
												</tr>
												<tr>
													<td className="resetFormTable">Email ID</td>
													<td className="resetFormTable">{email}</td>
												</tr>
												<tr>
													<td className="resetFormTable">First Name</td>
													<td className="resetFormTable">{given_name}</td>
												</tr>
												<tr>
													<td className="resetFormTable">Last Name</td>
													<td className="resetFormTable">{family_name}</td>
												</tr>
												<tr>
													<td className="resetFormTable">company</td>
													<td className="resetFormTable">{company}</td>
												</tr>
											</table>
											*/}

                  <Row>
                    <Col sm={6}>
                      <FormGroup>
                        <Label for="uid" id="uid" className="label">
                          User ID:
                        </Label>
                        <Label for="UIDVal" id="UIDVal">
                          {uid}
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={10}>
                      <FormGroup>
                        <Label for="email" id="email" className="label">
                          Email ID:
                        </Label>
                        <Label for="emailVal" id="emailVal">
                          {email}
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={10}>
                      <FormGroup>
                        <Label className="label">First Name:</Label>
                        <Label name="firstName">{given_name}</Label>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={10}>
                      <FormGroup>
                        <Label className="label">Last Name:</Label>
                        <Label name="lastName">{family_name}</Label>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={10}>
                      <FormGroup>
                        <Label className="label">Organization:</Label>
                        <Label name="company">{company}</Label>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <FormGroup>
                        <Label className="label">
                          Password:<span className="required">*</span>
                        </Label>
                        <Input
                          type="password"
                          name="password"
                          tag={Field}
                          placeholder="Enter password"
                          className="resetPasswordlabel"
                          onChange={(event) => {
                            setFieldValue("password", event.target.value);
                            setCurrState((prevState) => {
                              return {
                                ...prevState,
                                password: event.target.value,
                                errors: {},
                              };
                            });
                          }}
                        />
                        <ToolTip
                          style={{
                            padding: "3% 1%",
                            marginTop: "-40px",
                            marginLeft: "220px",
                          }}
                          message="Password must contain atleast 16 characters including uppercase, lowercase, number and special character"
                          target="folio"
                        />
                        <ErrorMessage
                          errors={errors.password}
                          touched={touched.password}
                        />{" "}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <FormGroup>
                        <Label className="label">
                          Confirm Password:<span className="required">*</span>
                        </Label>
                        <Input
                          type="password"
                          name="confirm_password"
                          placeholder="Enter confirm password"
                          className="resetPasswordlabel"
                          tag={Field}
                          onChange={(event) => {
                            setFieldValue(
                              "confirm_password",
                              event.target.value
                            );
                          }}
                        />
                        <ErrorMessage
                          errors={errors.confirm_password}
                          touched={touched.confirm_password}
                        />{" "}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Button
                    type="submit"
                    disabled={Boolean(
                      errors.password ||
                        errors.confirm_password ||
                        !values.password ||
                        !values.confirm_password
                    )}
                    style={{ float: "left" }}
                  >
                    Reset Password
                  </Button>
                </Form>
              </>
            )}
          </Formik>
        </Container>
      </Modal>
    </>
  );
}

export default ResetForm;
